(() => {
    class Product extends App.Entities.Model {
        constructor(data) {
            super(data);
        }
        adaptor() {
            const item = super.adaptor();
            // Offer
            this
                .setDynamicProperty('offer', () => App.Interface.Product.getOfferId(item.id))
                .setDynamicProperty('Offer', async () => App.Endpoint.Offers.getById(await item.offer))
                .setDynamicProperty('Design', async () => item.design ? await App.Endpoint.Designs.getById(item.design) : null)
                .setDynamicProperty('mixedNettPrice', async () => item.design ? await this.getMixedPrice(item) : item.price)
            ;
            // Description
            if (!item.description)
                item.description = item.expandedDescription ?
                    item.expandedDescription : () => item.Offer ? item.Offer.description : '';
            // Image
            if (typeof item.image !== 'string')
                item.image = item.imageIcon ?
                    item.imageIcon.path : (item.image ? item.image.path : '');
            // articleNumber
            item.article    = item.articleNumber;
            item.hints      = item.featuredAdditionalHints.slice(0, 2).join() || '';
            return item;
        }

        /**
         * Because the price includes the design price we have to
         * recalculate the price and subtract it to have the real mixed
         * price
         * @param item
         * @return {Promise<number|number>}
         */
        async getMixedPrice(item) {
            return item.price - (await item.Design).price || 0;
        }
    }
    App.Model.Product = Product;
})();
